import { Alert, Snackbar } from "@mui/material";
import { Modal, Popin, Text } from "$components";
import JImportModal from "$components/JImportModal/JImportModal";
import DockyardForm from "$containers/Dockyard/DockyardForm";
import ProjectForm from "../../ProjectForm";
import { ImportType } from "$types/import/ImportType";
import { useStyles } from "../styles";
import { ProjectDetailsLogic } from "../types";

type ProjectModalsProps = Pick<
  ProjectDetailsLogic,
  | "idProject"
  | "project"
  | "showImportModal"
  | "setShowImportModal"
  | "showImportEditModal"
  | "setShowImportEditModal"
  | "onImportFinish"
  | "openSnackbar"
  | "filters"
  | "modalActive"
  | "setModalActive"
  | "isProjectDisabled"
  | "enableProject"
  | "disableProject"
  | "errorUpload"
  | "setErrorUpload"
  | "errorMessage"
  | "handleCloseError"
  | "isOpened"
  | "togglePopin"
  | "formProject"
  | "handleSubmit"
  | "error"
  | "submitting"
  | "isDockyardPopinOpened"
  | "toggleDock"
  | "formDockyard"
  | "handleSubmitDock"
  | "errorDockyard"
  | "submittingDockyard"
  | "modalDeleteOpen"
  | "setModalDeleteOpen"
  | "deleteProject"
>;

export default function ProjectModals({
  idProject,
  project,
  showImportModal,
  setShowImportModal,
  showImportEditModal,
  setShowImportEditModal,
  onImportFinish,
  openSnackbar,
  filters,
  modalActive,
  setModalActive,
  isProjectDisabled,
  enableProject,
  disableProject,
  errorUpload,
  setErrorUpload,
  errorMessage,
  handleCloseError,
  isOpened,
  togglePopin,
  formProject,
  handleSubmit,
  error,
  submitting,
  isDockyardPopinOpened,
  toggleDock,
  formDockyard,
  handleSubmitDock,
  errorDockyard,
  submittingDockyard,
  modalDeleteOpen,
  setModalDeleteOpen,
  deleteProject,
}: ProjectModalsProps) {
  const clasx = useStyles();

  return (
    <>
      <JImportModal
        dataName="chantiers"
        showImportModal={showImportModal}
        contextId={idProject}
        setShowImportModal={setShowImportModal}
        type={ImportType.DOCKYARD_SIMPLE}
        onImportFinish={onImportFinish}
        openSnackbar={openSnackbar}
      />
      <JImportModal
        contextId={idProject}
        showImportModal={showImportEditModal}
        setShowImportModal={setShowImportEditModal}
        type={ImportType.DOCKYARD_SIMPLE_UPDATE}
        onImportFinish={onImportFinish}
        openSnackbar={openSnackbar}
        canExportData
        filters={filters}
        dataName="chantiers"
      />
      <Modal
        open={modalActive}
        onCancel={() => setModalActive(false)}
        className={clasx.modalDesactive}
        title="Attention"
        textValidate={isProjectDisabled ? "Activer" : "Désactiver"}
        onConfirm={isProjectDisabled ? enableProject : disableProject}
      >
        <div className={clasx.modalContainer}>
          {isProjectDisabled
            ? "Vous êtes sur le point de réactiver ce projet, êtes-vous sûr de vouloir continuer ?"
            : "Vous êtes sur le point de désactiver ce projet, êtes-vous sûr de vouloir continuer ?"}
        </div>
      </Modal>
      <Modal
        open={errorUpload !== ""}
        onCancel={() => {
          setErrorUpload("");
        }}
        className={clasx.modalDesactive}
        title="Attention"
        textValidate="Réessayer"
        onConfirm={() => {
          setErrorUpload("");
        }}
      >
        <div className={clasx.modalContainer}>{errorUpload}</div>
      </Modal>
      <Popin
        className={clasx.ProjectsPage_Popin}
        openPopin={isOpened}
        toggleDrawer={togglePopin}
      >
        <ProjectForm
          project={formProject}
          onSubmit={handleSubmit}
          projectError={error}
          onReset={() => togglePopin(false)}
          isSubmitting={submitting}
        />
      </Popin>
      <Popin
        className={clasx.ProjectsPage_Popin}
        openPopin={isDockyardPopinOpened}
        toggleDrawer={toggleDock}
      >
        <DockyardForm
          dockyard={formDockyard}
          defaultValuesForm={{
            project: project?._id,
            company: project?.company?._id,
          }}
          onSubmit={handleSubmitDock}
          onCancel={() => toggleDock(false)}
          error={errorDockyard}
          isSubmitting={submittingDockyard}
        />
      </Popin>
      <Modal
        open={modalDeleteOpen}
        onCancel={() => setModalDeleteOpen(false)}
        onValidate={async () => {
          setModalDeleteOpen(false);
          await deleteProject();
        }}
        textCancel="Annuler"
        textValidate="Supprimer"
        title="Confirmation de suppression"
      >
        <div style={{ textAlign: "center" }}>
          <Text>
            Vous êtes sur le point de supprimer définitivement ce projet.
            <br />
            Êtes-vous sûr de vouloir continuer ?
          </Text>
        </div>
      </Modal>
      <Snackbar
        open={!!errorMessage}
        autoHideDuration={6000}
        onClose={handleCloseError}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseError}
          severity="error"
          sx={{ width: "100%", fontSize: "14px" }}
        >
          {errorMessage}
        </Alert>
      </Snackbar>
    </>
  );
}
